import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import { Modal, Button, Grid, Row, Col, Breadcrumb, Thumbnail, Carousel} from 'react-bootstrap';
import ReactDOM from 'react-dom'

// images

import InfoJumb1 from './images/Jara_Zeitraffer_KBA40_vs_KMBM_V1_2.mp4';
import banner1 from './images/banner1.jpg';


class Jara extends Component {
  constructor(props, context) {
    super(props, context);


    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.state = {
      show: false,
      product: 'Default',
      listItemsProperties: '',
      listItemsPropertiesExt: '',
      sizeType: '',
      sizeData: '',
      sizeMeas: '',
      pdfLink: '',
      pdfAlias: '',
      image: '',
      carousel: ''
    };




  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }



  handleUpdate(product, carousel) {
    var productTmp = JSON.parse(product);
    var productArr = productTmp[0].prop;
    var carouselArr = JSON.parse(carousel)[0].item;
    this.setState({listItemsProperties: productArr.map((elementEx) =>
      <li key={elementEx.data}>{elementEx.data}</li>
    )});
    this.setState({carousel: carouselArr.map((elementCarousel) =>
      <Carousel.Item>
        <img className="productsDetailCarousel" src={"/supplier/jara/maschinen/"+elementCarousel.$.img} id={this.state.product + "_img_" + elementCarousel.$.id} alt={elementCarousel.$.alt}/>
        <Carousel.Caption>
          <h3>{elementCarousel.$.cap}</h3>
        </Carousel.Caption>
      </Carousel.Item>
    )});
  }

  render() {
    var data;
      var builtTmp;
      var parseString = require('xml2js').parseString;

        fetch('/supplier/jara/produkte/data_bohren.xml')
        .then((r) => r.text())
        .then(text  => {
          parseString(text, function (err, result) {
              data=result;
              var tmpOV = JSON.parse(JSON.stringify(result));
              data= tmpOV.maschinen.maschine;
              builtTmp = data.map((element) =>
              <Col xs={12} md={4}>
                <Thumbnail className="thumbNail" src={`/supplier/jara/maschinen/${element.Image}`} alt={element.Name}>
                  <h3>{element.Name}</h3>
                  <p>{element.sizeType}</p>
                  <p>{element.sizeMeas}</p>
                  <p>{element.sizeData}</p>
                  <br/>
                  <Button bsStyle="primary" onClick={() => {
                    this.setState({product: element.Name, sizeData: element.sizeData, sizeMeas: element.sizeMeas, sizeType: element.sizeType, pdfLink: element.pdfLink, pdfAlias: element.pdfAlias, image: `/supplier/jara/maschinen/${element.Image}`});
                    this.handleUpdate(JSON.stringify(element.properties), JSON.stringify(element.carousel));
                    this.handleShow();
                  }}>Mehr Informationen</Button>
                  <br/>
                </Thumbnail>
              </Col>

              );

            }.bind(this));
            this.builtElement = ReactDOM.render(builtTmp, document.getElementById('productsRoot'));
        });
    return (
      <div className='container-fluid'>

        <div className="supMain">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Jara</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt=""/>
        </div>
        <div className="supMainText">
          <h1>Jara</h1>
            <Grid className="supMainInfo">
              <Row>
                <Col xsHidden smHidden md={5}>
                   <video id="background-video" className="newsVideovideo" loop autoPlay muted playsInline="true">
                        <source src={InfoJumb1} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                  </Col>
                <Col xsHidden md={7}>
                  <h4>JARA Maschinenbau bietet seinen Kunden einfach zu bedienende und zuverlässige CNC-Koordinaten-Bohranlagen. Durch den modularen Aufbau ermöglicht Jara eine kundenspezifische Konfiguration ihrer Maschinen, um das optimale produkt für Sie herzustellen.
                </h4>
                </Col>
                <Col xs={12}  smHidden mdHidden lgHidden>
                  <h4>JARA Maschinenbau bietet seinen Kunden einfach zu bedienende und zuverlässige CNC-Koordinaten-Bohranlagen. Durch den modularen Aufbau ermöglicht Jara eine kundenspezifische Konfiguration ihrer Maschinen, um das optimale produkt für Sie herzustellen.
                </h4>
                </Col>
                <Col xs={12} md={{ span: 7, offset: 2 }}>
                  <Button className="supMainButtonWebPage" variant="light" href="https://www.jara-maschinenbau.de/" target="_blank">Hersteller Homepage</Button>
                </Col>
              </Row>
            </Grid>
            <br/>
        </div>



        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid>
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Langjährige Erfahrung und Expertise</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Bewährte Maschinenkonzepte</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Individuelle Lösungen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Höchste Qualitätsstandards</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Partnerschaftliche Zusammenarbeit</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>Umfassender Service</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Langjährige Erfahrung und Expertise</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Bewährte Maschinenkonzepte</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Höchste Qualitätsstandards</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; Umfassender Service</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>
          <br/>
          <center>
          <h1>Produkte</h1>
          </center>
          <br/><br/>
          <Grid className="gridUp" id="productsRoot">
          </Grid>
          <br/>
        </section>
        <Modal show={this.state.show} onHide={this.handleClose} >
          <Modal.Header closeButton>
            <Modal.Title>{this.state.product}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Carousel className="productsDetailCarousel">{this.state.carousel}</Carousel>
            <br/>
            <h5>{this.state.sizeType}</h5>
            <p>{this.state.sizeData} &nbsp; {this.state.sizeMeas}</p>
            <br/>
            <h5>Eigenschaften</h5>
            <ul className='unordEnumBase'>{this.state.listItemsProperties}</ul>
            <br/>
            <h5>Download</h5>
            <a href={this.state.pdfLink}>{this.state.pdfAlias}</a>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleClose}>Schließen</Button>
          </Modal.Footer>
        </Modal>
        </div>
    );
  }
}

export default Jara;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/jara/mainPageSup.js